import API from "../../api/api";
// import Auth from '../../auth.js';
import { Link } from "react-router-dom";
import React, { Component } from "react";
import "../../styles/css/users/signup.css";
// import Card from '@material-ui/core/Card';
import Select from "@material-ui/core/Select";
import { Header, Footer } from "../../components";
import MenuItem from "@material-ui/core/MenuItem";
import States from "../../components/States/States";
import TextField from "@material-ui/core/TextField";
// import Checkbox from '@material-ui/core/Checkbox';
// import CardContent from '@material-ui/core/CardContent';
// import HighlightOffIcon from '@material-ui/icons/HighlightOff';
// import FormControlLabel from '@material-ui/core/FormControlLabel';
import ErrorOutileIcon from "@material-ui/icons/ErrorOutline";
import CircularProgress from "@material-ui/core/CircularProgress";
import SuccessImage from "../../Images/Success.svg";
import QS from "querystring";

class CBSignup_titleCompanyAdmin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      firstname: "",
      lastname: "",
      designation: "",
      companyName: "",
      // email: "",
      einNo: "",
      license_no: "null",
      password: "",
      password2: "",
      contactNo: "",
      address: "",
      state: "null",
      zipCode: "",
      imgUrl: "url",
      userType: 2,
      register_token: "",

      firstnameEmpty: false,
      lastnameEmpty: false,
      designationEmpty: false,
      companyNameEmpty: false,
      // emailEmpty: false,
      einNoEmpty: false,
      license_noEmpty: false,
      addressEmpty: false,
      passwordEmpty: false,
      password2Empty: false,
      contactNoEmpty: false,
      stateEmpty: false,
      zipCodeEmpty: false,

      contactNoMinus: false,
      einNoMinus: false,
      zipCodeMinus: false,

      isCreationLoading: false,
      isSubmitted: false,
      submitError: "",
      userCreationSuccess: false,
      passwordNotMatched: false,
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.selectUserStateHandle = this.selectUserStateHandle.bind(this);
  }

  componentDidMount() {
    const query = QS.parse(this.props.location.search.replace("?", ""));
    console.log(query);
    if (!query.token) {
      this.props.history.replace("/");
    }
    this.setState({
      register_token: query.token,
    });
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    this.setState(
      {
        [name]: value,
      },
      () => this.checkMinus(name, value)
    );
  }

  checkMinus = (name, value) => {
    if (name === "contactNo" && value !== null && value < 0) {
      this.setState({ contactNoMinus: true });
    } else if (name === "contactNo" && value !== null && value >= 0) {
      this.setState({ contactNoMinus: false });
    }
    if (name === "einNo" && value !== null && value < 0) {
      this.setState({ einNoMinus: true });
    } else if (name === "einNo" && value !== null && value >= 0) {
      this.setState({ einNoMinus: false });
    }
    if (name === "zipCode" && value !== null && value < 0) {
      this.setState({ zipCodeMinus: true });
    } else if (name === "zipCode" && value !== null && value >= 0) {
      this.setState({ zipCodeMinus: false });
    }
    if (
      (name === "password2" &&
        value !== null &&
        value !== this.state.password) ||
      (name === "password" && value !== null && value !== this.state.password2)
    ) {
      this.setState({ passwordNotMatched: true });
    } else if (
      (name === "password2" &&
        value !== null &&
        value === this.state.password) ||
      (name === "password" && value !== null && value === this.state.password2)
    ) {
      this.setState({ passwordNotMatched: false });
    }
  };

  selectUserStateHandle(event) {
    this.setState({ state: event.target.value });
  }

  handleSubmit(event) {
    event.preventDefault();

    this.setState({ isCreationLoading: true });

    const Userdata = {
      companyName: this.state.companyName,
      // email: this.state.email,
      einNo: this.state.einNo,
      license_no: this.state.license_no,
      password: this.state.password,
      password2: this.state.password2,
      contactNo: this.state.contactNo,
      address: this.state.address,
      state: this.state.state,
      zipCode: this.state.zipCode,
    };

    Object.keys(Userdata).forEach((key) => {
      if (Userdata[key] === "") {
        this.setState({
          [`${key}Empty`]: true,
        });
      } else {
        this.setState({
          [`${key}Empty`]: false,
        });
      }
    });
    if (this.state.state === "null") {
      this.setState({
        stateEmpty: true,
      });
    } else {
      this.setState({
        stateEmpty: false,
      });
    }

    const user = {
      first_name: this.state.firstname,
      last_name: this.state.lastname,
      designation: this.state.designation,
      name: this.state.companyName || "",
      // email: this.state.email,
      password: this.state.password,
      password_confirmation: this.state.password2,
      mobile_no: this.state.contactNo,
      ein: this.state.einNo,
      license_no: this.state.license_no,
      address: this.state.address,
      state: this.state.state,
      zipcode: this.state.zipCode,
      image_url: this.state.imgUrl,
      type: this.state.userType,
      register_token: this.state.register_token,
    };

    if (
      this.state.firstname !== "" &&
      this.state.lastname !== "" &&
      this.state.designation !== "" &&
      this.state.companyName !== "" &&
      // this.state.email !== "" &&
      this.state.license_no !== "" &&
      this.state.einNo !== "" &&
      this.state.password !== "" &&
      this.state.password2 !== "" &&
      this.state.contactNo !== "" &&
      this.state.address !== "" &&
      this.state.state !== "null" &&
      !(this.state.zip_code < 0) &&
      !(this.state.contactNo < 0) &&
      !(this.state.einNo < 0) &&
      this.state.zipCode !== "" &&
      !this.state.passwordNotMatched
    ) {
      API.post("user", user)
        .then((res) => {
          console.log("res", res);
          this.setState({ isCreationLoading: false });
          this.showCreationMessage(true);
          this.clearAllFields();
        })
        .catch((err) => {
          console.log("AXIOS ERROR: ", err);
          const resp = err.response.data;

          this.setState({
            isCreationLoading: false,
            submitError:
              resp.error.constructor === {}.constructor
                ? resp.error[Object.keys(resp.error)[0]]
                : resp.error,
          });
          this.showCreationMessage(false);
        });
    } else {
      this.setState({ isCreationLoading: false });
    }
  }

  showCreationMessage = (success) => {
    if (success) {
      window.location.href = "/signin";
    }
    // this.setState({
    //   isSubmitted: true,
    //   userCreationSuccess: success ? true : false,
    // });
    // setTimeout(() => {
    //   this.setState({
    //     isSubmitted: false,
    //     userCreationSuccess: true,
    //   });
    //   if (success) {
    //     // window.location.href = "/browseguest/str";
    //     window.location.href = "/";
    //   }
    // }, 3000);
  };

  clearAllFields = () => {
    this.setState({
      firstname: "",
      lastname: "",
      companyName: "",
      email: "",
      einNo: "",
      license_no: "null",
      password: "",
      password2: "",
      contactNo: "",
      address: "",
      state: "null",
      zipCode: "",
      imgUrl: "url",
      userType: 2,

      firstnameEmpty: false,
      lastnameEmpty: false,
      companyNameEmpty: false,
      emailEmpty: false,
      einNoEmpty: false,
      license_noEmpty: false,
      addressEmpty: false,
      passwordEmpty: false,
      password2Empty: false,
      contactNoEmpty: false,
      stateEmpty: false,
      zipCodeEmpty: false,
    });
  };

  render() {
    const { isSubmitted, userCreationSuccess, isCreationLoading } = this.state;

    return (
      <div className={`mainDiv`}>
        <Header />
        <div className="signInMain">
          <div className="landingMainHead landingMainHeadSign landingMainHeadReg">
            <div className="landingMain registerMain">
              <div className="breadCrubmContainer removePadding breadCrubmContainerSign">
                <div className="breadCrumb">
                  <a href="https://surveysource.com/" className="prevLinks">
                    Home
                  </a>
                  <span>&nbsp;&gt;&nbsp;</span>
                  <span className="currLink">Titlecompany signup</span>
                </div>
              </div>
              <div className="landingMainLeftSign landingMainLeftReg">
                <div className="landingMainActives">
                  <p className="loginMainActivesTitle landingMainActivesTitleReg">
                    Signup to get started
                  </p>
                </div>
                <div className="logingFormMain registerFormMain">
                  <div className="overlayMessage_wrapper">
                    <div
                      style={
                        userCreationSuccess
                          ? { height: "660px", padding: "15px 15px" }
                          : { height: "0px", padding: "0px 15px" }
                      }
                      className="overlayMessage"
                    >
                      <img className="iconImage" src={SuccessImage} alt="" />
                      <h1>Pending Request !</h1>
                      <p>
                        We will get back to you via email, after our admin
                        approve your request
                      </p>

                      <span>
                        <Link to="/" className="">
                          Back to home
                        </Link>
                      </span>
                    </div>
                  </div>

                  <form onSubmit={this.handleSubmit}>
                    <div className="formTwoInputs">
                      {/* First Name */}
                      <div className="formInputRow">
                        <TextField
                          id="firstname"
                          label="First name"
                          className="fullWidth"
                          fullWidth
                          margin="normal"
                          name="firstname"
                          value={this.state.firstname}
                          onChange={this.handleInputChange}
                          required
                        />
                        <div
                          className="ErrorLog ErrorLogReg"
                          style={{
                            display: this.state.firstnameEmpty
                              ? "block"
                              : "none",
                          }}
                        >
                          <span>Name is required</span>
                        </div>
                      </div>
                      {/* Last Name */}
                      <div className="formInputRow">
                        <TextField
                          id="lastname"
                          label="Last name"
                          className="fullWidth"
                          fullWidth
                          margin="normal"
                          name="lastname"
                          value={this.state.lastname}
                          onChange={this.handleInputChange}
                          required
                        />
                        <div
                          className="ErrorLog ErrorLogReg"
                          style={{
                            display: this.state.lastnameEmpty
                              ? "block"
                              : "none",
                          }}
                        >
                          <span>Last Name is required</span>
                        </div>
                      </div>
                    </div>
                    <div className="formTwoInputs">
                      {/* Email */}
                      {/* <div className="formInputRow">
                        <TextField
                          id="email"
                          label="Email"
                          className="fullWidth"
                          fullWidth
                          margin="normal"
                          name="email"
                          type="email"
                          value={this.state.email}
                          onChange={this.handleInputChange}
                          required
                        />
                        <div
                          className="ErrorLog ErrorLogReg"
                          style={{
                            display: this.state.emailEmpty ? "block" : "none",
                          }}
                        >
                          <span>Email is required</span>
                        </div>
                      </div> */}
                      {/* Phone */}
                      <div className="formInputRow">
                        <TextField
                          id="contactNo"
                          label="Phone number"
                          className="fullWidth"
                          type="number"
                          fullWidth
                          margin="normal"
                          name="contactNo"
                          value={this.state.contactNo}
                          onChange={this.handleInputChange}
                          required
                        />
                        <div
                          className="ErrorLog ErrorLogReg"
                          style={{
                            display: this.state.contactNoEmpty
                              ? "block"
                              : "none",
                          }}
                        >
                          <span>Phone number is required</span>
                        </div>
                        <div
                          className="ErrorLog ErrorLogReg"
                          style={{
                            display: this.state.contactNoMinus
                              ? "block"
                              : "none",
                          }}
                        >
                          <span>Minus values are not allowed</span>
                        </div>
                      </div>
                    </div>
                    <div className="formOneInput">
                      {/* Company Name */}
                      <div className="formInputRowFull">
                        <TextField
                          id="companyName"
                          label="Company name"
                          className="fullWidth"
                          fullWidth
                          margin="normal"
                          name="companyName"
                          value={this.state.companyName}
                          onChange={this.handleInputChange}
                          required
                        />
                        <div
                          className="ErrorLog ErrorLogReg"
                          style={{
                            display: this.state.companyNameEmpty
                              ? "block"
                              : "none",
                          }}
                        >
                          <span>Company name is required</span>
                        </div>
                      </div>
                    </div>
                    <div className="formTwoInputs">
                      {/* Designation */}
                      <div className="formInputRow">
                        <TextField
                          id="designation"
                          label="Title"
                          className="fullWidth"
                          fullWidth
                          margin="normal"
                          name="designation"
                          value={this.state.designation}
                          onChange={this.handleInputChange}
                          required
                        />
                        <div
                          className="ErrorLog ErrorLogReg"
                          style={{
                            display: this.state.designationEmpty
                              ? "block"
                              : "none",
                          }}
                        >
                          <span>Designation is required</span>
                        </div>
                      </div>
                      {/* EIN/Tax */}
                      <div className="formInputRow">
                        <TextField
                          id="einNo"
                          label="EIN/Tax ID"
                          className="fullWidth"
                          type="text"
                          fullWidth
                          margin="normal"
                          name="einNo"
                          value={this.state.einNo}
                          onChange={this.handleInputChange}
                          required
                        />
                        <div
                          className="ErrorLog ErrorLogReg"
                          style={{
                            display: this.state.einNoEmpty ? "block" : "none",
                          }}
                        >
                          <span>EIN is required</span>
                        </div>
                        <div
                          className="ErrorLog ErrorLogReg"
                          style={{
                            display: this.state.einNoMinus ? "block" : "none",
                          }}
                        >
                          <span>Minus values are not allowed</span>
                        </div>
                      </div>
                    </div>
                    <div className="formOneInput">
                      {/* Address */}
                      <div className="formInputRowFull">
                        <TextField
                          id="address"
                          label="Company address"
                          className="fullWidth"
                          fullWidth
                          margin="normal"
                          name="address"
                          value={this.state.address}
                          onChange={this.handleInputChange}
                          required
                        />
                        <div
                          className="ErrorLog ErrorLogReg"
                          style={{
                            display: this.state.addressEmpty ? "block" : "none",
                          }}
                        >
                          <span>Address is required</span>
                        </div>
                      </div>
                    </div>
                    <div className="formTwoInputs">
                      {/* State */}
                      <div className="formInputRow">
                        <Select
                          value={this.state.state}
                          onChange={this.selectUserStateHandle}
                          className={`fullWidth marginBotMin selectField`}
                          inputProps={{
                            name: "states",
                            id: "selectUserState",
                          }}
                          required
                        >
                          <MenuItem value={"null"}>Select State*</MenuItem>
                          {States.map((state) => {
                            return (
                              <MenuItem key={state.name} value={state.name}>
                                {state.name}
                              </MenuItem>
                            );
                          })}
                        </Select>
                        <div
                          className="ErrorLog ErrorLogReg"
                          style={{
                            display: this.state.stateEmpty ? "block" : "none",
                          }}
                        >
                          <span>State is required</span>
                        </div>
                      </div>
                      {/* Zip Code */}
                      <div className="formInputRow">
                        <TextField
                          id="zipCode"
                          label="Zip code"
                          className="fullWidth"
                          type="number"
                          fullWidth
                          margin="normal"
                          name="zipCode"
                          value={this.state.zipCode}
                          onChange={this.handleInputChange}
                          required
                        />
                        <div
                          className="ErrorLog ErrorLogReg"
                          style={{
                            display: this.state.zipCodeEmpty ? "block" : "none",
                          }}
                        >
                          <span>Zip code is required</span>
                        </div>
                        <div
                          className="ErrorLog ErrorLogReg"
                          style={{
                            display: this.state.zipCodeMinus ? "block" : "none",
                          }}
                        >
                          <span>Minus values are not allowed</span>
                        </div>
                      </div>
                    </div>
                    <div className="formTwoInputs">
                      {/* Password */}
                      <div className="formInputRow">
                        <TextField
                          id="password"
                          label="Password"
                          className="fullWidth"
                          fullWidth
                          margin="normal"
                          name="password"
                          type="password"
                          value={this.state.password}
                          onChange={this.handleInputChange}
                          required
                        />
                        <div
                          className="ErrorLog ErrorLogReg"
                          style={{
                            display: this.state.passwordEmpty
                              ? "block"
                              : "none",
                          }}
                        >
                          <span>Password is required</span>
                        </div>
                      </div>
                      {/* Confirm Password */}
                      <div className="formInputRow">
                        <TextField
                          id="password2"
                          label="Retype password"
                          className="fullWidth"
                          type="password"
                          fullWidth
                          margin="normal"
                          name="password2"
                          value={this.state.password2}
                          onChange={this.handleInputChange}
                          required
                        />
                        <div
                          className="ErrorLog ErrorLogReg"
                          style={{
                            display: this.state.password2Empty
                              ? "block"
                              : "none",
                          }}
                        >
                          <span>Password confirmation is required</span>
                        </div>
                        <div
                          className="ErrorLog ErrorLogReg"
                          style={{
                            display: this.state.passwordNotMatched
                              ? "block"
                              : "none",
                          }}
                        >
                          <span>Passwords are not matched!</span>
                        </div>
                      </div>
                    </div>
                    <button type="submit" className="loginBtn regBtn">
                      {isCreationLoading ? (
                        <CircularProgress className="circularColor1" />
                      ) : (
                        <div>
                          <span>Signup</span>
                        </div>
                      )}
                    </button>
                    <div
                      className="userCreationMessage messageDiv"
                      id="userCreationMessage"
                    >
                      {isSubmitted ? (
                        userCreationSuccess ? (
                          <div className="messageBody messageDivSub userCreationSuccessColor">
                            {/* <div className="messageAction">
                              <ErrorOutileIcon />
                            </div>
                            <div className="userCreationSuccess">User has been created successfully</div> */}
                          </div>
                        ) : (
                          <div className="messageBody messageDivSub userCreationFailColor">
                            <div className="messageAction">
                              <ErrorOutileIcon />
                            </div>
                            <div className="userCreationFail">
                              {/* The email has already been taken */}
                              {this.state.submitError}
                            </div>
                          </div>
                        )
                      ) : null}
                    </div>
                    <div className="registrationLinks2 registrationLinks2Mobile">
                      <span>Already have an account ?&nbsp;</span>
                      <div>
                        <Link
                          to="/signin"
                          className="registerLink registerLinkMobile"
                        >
                          Login here
                        </Link>
                      </div>
                    </div>
                  </form>
                  <div
                    className="messageBody messageDivSub userCreationSuccessColor regNotification"
                    style={
                      userCreationSuccess
                        ? { display: "block" }
                        : { display: "none" }
                    }
                  >
                    <div className="messageAction messageActionReg">
                      <ErrorOutileIcon />
                    </div>
                    <div className="userCreationSuccess">
                      Signup request will be sent to our Administrator, we will
                      get in touch with you soon via E-mail.
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="landingMainRight">
              <img src="/static/images/loging_home.svg" alt="loging_home" />
            </div> */}
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

export default CBSignup_titleCompanyAdmin;



// WEBPACK FOOTER //
// ./src/pages/Users/CBSignup_titleCompanyAdmin.js